import { SET_HVI_DATA } from "../types";
export const getHviData = (hvi) => (dispatch) => {
    dispatch({ type: SET_HVI_DATA, payload: hvi });
    return { data: hvi };
};
